import Navbarsec from "./Navbarsec";
export default function Blogs() {
    return (
     <div>
       <Navbarsec />
       <section class="bg-white dark:bg-gray-900">
     <div class="py-8 px-4 mx-auto max-w-screen-md text-center lg:py-16 lg:px-12">
     <img src="https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExOWhhdjdhbmNsOWZmZG9iamp0bG5ydGFoamF0NWFtODFsNnlpbm42cyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/VeerK4hE9sjoB8e6OQ/giphy.gif" alt="Blogs Icon" className="mx-auto mb-4  text-gray-400" />
         <h1 class="mb-4 text-4xl font-bold tracking-tight leading-none text-gray-900 lg:mb-6 md:text-5xl xl:text-6xl dark:text-white">Blogs Coming Soon</h1>
         <p class="font-light text-gray-500 md:text-lg xl:text-xl dark:text-gray-400">We are working on exciting new content for our blog. Stay tuned!</p>
     </div>
 </section>
     </div>
   );
 }
 